import ChargePayout from "../../Models/ChargePayout";
import "../UserCharges/Charges.css"

interface Props{
    chargePayout: ChargePayout;
}


const PayoutCard = (props:Props) =>{
    const isActive = props.chargePayout.payoutStatus === 0;

    function getDateInputFormat(newDate: Date): string {
        const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
        const date: Date = new Date(newDate);
        const dateStringFormat: string = `${zeroPad(date.getDate(), 2)}-${zeroPad(date.getMonth() + 1, 2)}-${date.getFullYear()}`;
        return dateStringFormat;
    }

    return(
        <div className="payout-card" style={{ '--border-color-active': isActive ? '#36A70E' : '#2F5FA1'} as React.CSSProperties}>

        
            <div>
                <p className={isActive ? "card-payoutstatus-active" : "card-payoutstatus-paid"}>{isActive ? "Actief" : "Uitbetaald"}</p>
                <p>{getDateInputFormat(props.chargePayout.payoutDate)}</p>
            </div>
            <p className="payout-total">Totaal: €{props.chargePayout.payoutTotal.toFixed(2)}</p>
            
        </div> 
    )

    
}






export default PayoutCard



